import styled, { css } from 'styled-components';
import { Media } from 'assets/Mixins.style';

import { Container as CommonContainer } from 'assets/Common/Layout';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}
`;

export const Container = styled.div`
  ${CommonContainer}
`;

export const Box = styled.div`
  display: grid;

  width: 100%;
  //grid-gap: 15px;
  grid-template-columns: 25% 25% 25% 25%;
  align-items: flex-start;

  ${Media.md`
    grid-template-columns: 50% 50%;
  `}

  ${Media.sm`
    grid-template-columns: 100%;
  `}
  ${props =>
    props.differentGrid &&
    css`
      grid-template-columns: 1fr 12fr 4fr;
      ${Media.xxlg`
      grid-template-columns: 1fr 9fr 3fr;
      `}
      ${Media.sm`
      grid-template-columns: 85px 1fr;
      `}
    `}
`;

export const Column = styled.div`
  display: block;
  width: 100%;
  cursor: default;
  border-right: ${props => !props.noBorder && props.theme.border};
  height: 100%;
  padding: ${props => props.theme.padding || '0 8px'};

  ${Media.lg`
    text-align: ${props => props.theme.textAlignLg || 'center'};
  `}

  ${Media.sm`
    border-bottom: ${props => !props.noBorder && props.theme.border};
    border-right: none;
  `}
  ${props =>
    props.differentColumn0 &&
    css`
      grid-area: 1/1/2/2;
    `}
  ${props =>
    props.differentColumn1 &&
    css`
      grid-area: 1/2/2/3;
    `}
  ${props =>
    props.differentColumn2 &&
    css`
      grid-area: 2/1/3/3;
      ${Media.xxlg`
      grid-area: 3/1/3/4;
        
      `}
    `}
  ${props =>
    props.differentColumn3 &&
    css`
      grid-area: 2/3/3/4;
      ${Media.xxlg`
        grid-area: 2/1/3/4;
      `}
    `}
 ${props =>
   props.theme.paddingInline &&
   css`
     padding-inline: ${props.theme.paddingInline};
     &:first-child {
       padding-left: 0;
     }
     &:last-child {
       padding-right: 0;
     }
     ${Media.md`
      padding-inline: 0;
      padding-top: 20px;
      &:first-child {
        padding-top:0;
      }
    `}
   `}

   
`;

export const Text = styled.div`
  display: block;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  a {
    color: ${props => props.theme.link.color};

      &:hover{
        color: ${props => props.theme.link.colorOnHover};
      }
  }
`;
